import profile from "../assets/photos/profile7.jpg"


const logotext = "MANI";
const meta = {
    title: "Manimohan Thiriloganathan",
    description: "Manimohan Thiriloganathan - Analog, Mixed-Signal & RF IC Design Enthusiast with interests in ML/AI, embedded systems, and software development.",
};

const introdata = {
    title: "I’m Manimohan Thiriloganathan",
    animated: {
        first: "Passionate Electronic Engineer with expertise in IC, circuit, and system design.",
        second: "Enthusiastic about developing intelligent solutions using ML/AI.",
        Third: "Skilled in crafting user-focused interfaces as a software and graphics engineer.",
    },
    description: "I am a highly motivated and confident graduate from the Department of Electronic and Telecommunication Engineering at the University of Moratuwa.",
    your_img_url: profile,
};

const dataabout = {
    title: "About Me",
    aboutme: "I am a highly motivated and confident graduate from the Department of Electronic and Telecommunication Engineering at the University of Moratuwa, with B.Sc. Eng. (Hons) in Electronics and Telecommunication Engineering (First Class Honours), and a strong interest in ultra-low-power analog, mixed-signal, and RF integrated circuit design, including neuromorphic and high-speed systems, VLSI, and AI/ML. I believe in teamwork and always strive to achieve the best outcomes for the company.",
};

const educationtimeline = [
    {
        jobtitle: "B.Sc (Hons) in Electronic and Telecommunication Engineering",
        where: "University of Moratuwa",
        date: "Jun 2021 – Jun 2025"
    },
    {
        jobtitle: "Minor degree in Mathematics",
        where: "University of Moratuwa",
        date: "Jun 2021 – Jun 2025"
    },
    {
        jobtitle: "Human Resource Management",
        where: "International Business Management Institute",
        date: "Sep 2019 – Mar 2020"
    },
    {
        jobtitle: "Grade 1 – G.C.E Advanced Level",
        where: "Mahajana College, Jaffna",
        date: "Jan 2005 – Aug 2019"
    }
];

const worktimeline = [
    {
        jobtitle: "Junior Lecturer",
        where: "Dept. of Electronic & Telecommunication Eng., Univ. of Moratuwa",
        date: "Oct 2025 – April 2026"
    },
    {
        jobtitle: "Temporary Instructor",
        where: "Dept. of Electrical & Electronic Eng., Univ. of Jaffna",
        date: "July 2025 – Sep 2025",
        details: "Conducted labs/practicals for Analog & Digital Electronics (Level 1, 4)."
    },
    {
        jobtitle: "Visiting Lecturer",
        where: "Electronic and Telecommunication Engineering - University of Moratuwa",
        date: "Jan 2025 - May 2025"
    },
    {
        jobtitle: "Visiting Research Student (ML & AI)",
        where: "Singapore University of Technology and Design (SUTD)",
        date: "Nov 2023 – Dec 2024",
        details: "Worked on ML for advanced vision systems and additive manufacturing (AM) closed-loop control; contributed to a research paper."
    },
    {
        jobtitle: "AI/ML Intern",
        where: "iPartnerX Canada, Software Department",
        date: "Aug 2024 – Nov 2024",
        details: "Assisted with development of the AI Interview Platform."
    },
    {
        jobtitle: "Graphic Designer",
        where: "Creative Gift Collections, Singapore",
        date: "Feb 2024 - Present"
    },
];

const skills = [
   {
    category: "IC Design, Circuit Design and Simulation & 3D Modeling",
    items: [
        "Cadence Virtuoso",
        "Xschem",
        "Klayout",
        "VC Spyclass",
        "Quartus & ModelSim",
        "Vivado & Vitis",
        "Altium",
        "MATLAB",
        "Webots",
        "LTSpice",
    ]
},

    {
        category: "Machine Learning Frameworks",
        items: ["PyTorch", "TensorFlow", "SciKit Learn", "Keras"]
    },
    {
        category: "Programming Languages",
        items: ["Python", "C/C++", "JavaScript", "MATLAB", "LaTeX", "SQL", "Java"]
    },
    {
        category: "Web Development Frameworks",
        items: ["React Native", "React", "Angular", "Django", "Node.js", "Flutter", "Flask"]
    },
    {
        category: "Development Tools & Compilers",
        items: ["Visual Studio", "Git/GitHub", "Jupyter Notebook", "Google Colab"]
    },
    {
        category: "Graphic Designing",
        items: ["Photoshop", "Premiere Pro", "After Effects"]
    }
];


const socialprofils = {
    linkedin: "https://www.linkedin.com/in/tmanimohan",
    github: "https://github.com/Manimohan05",
    medium:"https://medium.com/@manimohan517",
    kaggle:"https://www.kaggle.com/tmanimohan",
    
};
export {
    meta,
    dataabout,
    educationtimeline,
    worktimeline,
    skills,
    introdata,
    socialprofils,
    logotext,
};